<template>
  <intersect @enter="animate = true">
    <div class="right fadeUp" v-if="itemData" :class="animate ? 'animate' : ''">
      <div class="polTtl noto-semibold">
        {{ _.get(itemData, "conf.header.title") }}
      </div>
      <div class="polDescr">{{ _.get(itemData, "conf.header.teaser") }}</div>
      <div class="policiesLinkImg">
        <picture>
          <source
            media="(max-width: 767px)"
            :srcset="_.get(itemData.data[0], 'cover_image.0.devices.mobile')"
          />
          <source
            media="(max-width: 1023px)"
            :srcset="_.get(itemData.data[0], 'cover_image.0.devices.tablet')"
          />
          <img
            :src="_.get(itemData.data[0], 'cover_image.0.devices.desktop')"
            class="img-absolute scale-anim"
            alt
            :class="animate ? 'animate' : ''"
          />
        </picture>
        <div class="descr">
          <div class="ttl">{{ _.get(itemData.data[0], "title") }}</div>
          <router-link
            :to="_.get(itemData.data[0], 'smartbuttons[0].url')"
            class="btn"
            >{{ _.get(itemData.data[0], "smartbuttons[0].title") }}</router-link
          >
        </div>
      </div>
    </div>
  </intersect>
</template>

<script>
import Intersect from "vue-intersect";

export default {
  props: {
    itemData: Object,
    required: true,
  },
  components: { Intersect },
  data() {
    return {
      animate: false,
    };
  },
};
</script>